<script setup>
import { computed } from "vue"
import { stringNumber, buyAlien, getCoinUrl } from "../../helpers/functions.js"
import { galaxies } from '../../staticData'
import { storage } from '../../storage'
const props = defineProps(['alien'])
const getUrl = (src) => {
    return `/spacebar-clicker/assets/aliens/${src}.png`
}

function buy(n = 1) {
    const isEnough = n === 1 ? !isNotEnough.value : !isNotEnough10.value
    if (isEnough && (!props.alien.minGalaxyInd || storage.GALAXY_IND >= props.alien.minGalaxyInd))
        buyAlien(props.alien.name, n)
}

const isNotEnough = computed(() => {
    return addPrice1.value > storage.COINS
})
const isNotEnough10 = computed(() => {
    return addPrice10.value > storage.COINS
})


const alienBoost = computed(() => {
    const level = storage.UPGRADES_LVLS.alienBoost[props.alien.id]
    return level > 0 ? ` L${level}` : ''
})
const earnings = computed(() => stringNumber(props.alien.amountEarning()))
const addEarnings1 = computed(() => stringNumber(props.alien.amountEarning(props.alien.amount + 1), true))
const addEarnings10 = computed(() => stringNumber(props.alien.amountEarning(props.alien.amount + 10), true))
const addPrice1 = computed(() => props.alien.upgradeCost())
const addPrice10 = computed(() => props.alien.upgradeCost(10))
const glassesClasses = computed(() => {
    if (storage.UPGRADES_LVLS.alienBoost[props.alien.id] > 0) {
        const classes = ['glasses', `id-${props.alien.id}`, `type-${storage.UPGRADES_LVLS.alienBoost[props.alien.id]}`]
        return classes
    }
    else return null
})
const isTutorialBtn = computed(() => props.alien.id === 1 ? true : false)
</script>

<template>
    <div class="cols-wrap">
        <div class="left-wrap">
            <div class="alien-img rotating" >
                <img v-if="glassesClasses"
                :class="[...glassesClasses]"
                :src="`/spacebar-clicker/assets/glasses/glasses${storage.UPGRADES_LVLS.alienBoost[props.alien.id]}.png`"
                alt="glasses">
                <img :src="getUrl(alien.imgSrc)" alt="alien" >
            </div>
            <p v-if="!alien.minGalaxyInd || storage.GALAXY_IND >= alien.minGalaxyInd">X {{ alien.amount }}</p>
        </div>
        <div class="right-wrap">
            <p class="header">{{ alien.name }} {{ alienBoost }}</p>
            <p class="locked" v-if="alien.minGalaxyInd && storage.GALAXY_IND < alien.minGalaxyInd">Will be unlocked in the {{ galaxies[alien.minGalaxyInd].name }} galaxy</p>
            <template v-else>
                <p class="row earnings" >Earns: <img class="coin-sm" :src="getCoinUrl()" alt="">{{ earnings }}/s</p>
                <div class="col">
                    <div class="row">
                        <div class="buy-btn action-btn" :class="{ 'disabled': isNotEnough }" :id="isTutorialBtn ? 'first-buy-btn' : ''" @click="buy()">
                            <span class="speed">↝ {{ addEarnings1 }}/s</span>
                            <span class="price"><img class="coin-sm" :src="getCoinUrl()" alt="">{{ stringNumber(addPrice1, true) }}</span>
                        </div>
                        <p class="amount">x1</p>
                    </div>
                    <div class="row">
                        <div class="buy-btn action-btn" style="background-color: aqua;" :class="{ 'disabled': isNotEnough10 }" @click="buy(10)">
                            <span class="speed">↝ {{ addEarnings10 }}/s</span>
                            <span class="price"><img class="coin-sm" :src="getCoinUrl()" alt="">{{ stringNumber(addPrice10, true) }}</span>
                        </div>
                        <p class="amount to-right">x10</p>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<style scoped>
.locked {
    text-align: center;
    position: relative;
    top: -50px;
    max-width: 200px;
    font-size: 1.2rem;
    color: grey;
}

.alien-img img.glasses {
    position: absolute;
    top: 32px;
    /* width: 100%; */
    left: 50%;
    transform: translateX(-50%);
    height: auto;
    z-index: 100;
}

img.glasses.id-12 {
    top: 26px;
    transform: translateX(-41%) rotate(352deg);
    width: 70px;
    /* transform:; */

}

img.glasses.id-4 {
    transform: translateX(-56%);
}

img.glasses.id-6 {
    top: 37px;
    transform: translateX(-46%);
}

.alien-img img.glasses.type-5 {
    top: 20px;
}

img.glasses.type-2 {
    top: 35px;
}


.earnings {
    height: 1.5rem;
    justify-content: flex-start;
    align-items: baseline;
}

.buy-btn {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 80%;
    /* min-width: 130px; */
    height: fit-content;
    padding: 0.31rem 0.75rem;
}

.buy-btn:hover {
    cursor: pointer;
}

.buy-btn span {
    color: black;
}

.buy-btn .speed {
    font-size: 0.9rem;
    color: blue;
}

.buy-btn .price {
    height: 100%;
    display: flex;
    align-items: flex-end;
    margin-top: 5px;
}

.buy-btn .price img {
    margin-right: 5px;
}

.amount {
    position: relative;
    margin-left: 10px;
    padding-right: 10px;
    right: -10px;
}

.amount.to-right {
    margin-left: 0;
}

.cols {
    display: flex;
    width: 100%;
}

.cols .action-btn {
    width: 50%;
}

.upgrade {
    height: 50px;
    position: absolute;
    transform: scaleX(-1);
    bottom: 0;
    right: 5px;
}

.discount {
    width: 30px;
    position: absolute;
    /* transform: scaleX(-1); */
    top: 0;
    right: 0;
}


.action-btn {
    margin-top: 5px;
}

.hidden .buy-btn {
    opacity: 0;
}

.hidden p {
    opacity: 0;
}

.hidden .header {
    opacity: 1;
}


.alien-img {
    height: 6.25rem;
    width: fit-content;
    overflow: visible;
    position: relative;
}

.alien-img img {
    height: 100%;
}


.cols-wrap .left-wrap {
    justify-content: space-around;
    overflow: visible;
    height: 100%;
    min-width: 100px;
    width: 40%;
    margin-right: 10px;
    align-items: center;
}

.right-wrap {
    /* display: flex;
    flex-direction: column;
    justify-content: space-between;*/
    height: 100%;
    width: 60%;
}

.right-wrap .col {
    height: calc(100% - 1rem);
}

.right-wrap .col .row {
    height: 50%;
}

.right-wrap .header {
    font-size: 1.1rem;
    color: #ff6320;
    text-align: center;
    font-weight: 600;
}

#column-wrap p {
    overflow: visible;
}


.rotating {
    animation: rotateAnimation 1s infinite alternate linear;
}

@keyframes rotateAnimation {
    0% {
        /* transform: rotate(315deg); */
        transform: rotate(-25deg);
    }

    100% {
        transform: rotate(25deg);
    }

}

@media (max-width: 1000px) {

    .alien-img img.glasses {
        top: 23px;
    }

    img.glasses.type-2.id-1,
    img.glasses.type-2.id-4 {
        top: 26px;
    }

    img.glasses.id-6 {
        top: 28px;
    }

    img.glasses.type-4.id-1 {
        top: 26px;
    }

    .alien-img img.glasses.type-5.id-1,
    .alien-img img.glasses.type-5.id-6 {
        top: 17px;
    }

    .alien-img img.glasses.type-5 {
        top: 15px;
    }

    .alien-img img.glasses.type-5.id-8 {
        top: 11px;
    }
}

@media screen and (max-width: 1200px) {

    .cols-wrap .left-wrap {
        min-width: unset;
        justify-content: flex-end;
    }

    .locked {
        max-width: 100px;
        height: fit-content;
        top: 0;
    }

    .right-wrap {
        position: static;
        justify-content: center;
    }

    .right-wrap .header {
        position: absolute;
        top: 5px;
        left: 7px;
    }

    .amount {
        padding-right: 0;
        right: 0;
    }

}

@media screen and (max-height:450px) and (max-width: 700px) {
    .cols-wrap {
        height: 140px;
        padding: 2px 3px 0;
    }

    .cols-wrap .left-wrap {
        margin-right: 0;
    }

    .right-wrap .header {
        font-size: 0.9rem;
    }

    .alien-img {
        height: 80px;
    }

    .buy-btn.action-btn {
        padding: 0;
    }
}
</style>